import * as dayjs from 'dayjs';
import React from 'react'
import { useState } from 'react'
import { Button, Card, Row, Col, } from 'react-bootstrap'
import { Table } from 'rsuite';
import LegacyPlusIcon from "@rsuite/icons/legacy/Plus";
import LegacyEdit2Icon from "@rsuite/icons/legacy/Edit2";
import LegacyTrashIcon from "@rsuite/icons/legacy/Trash";
import Swal from 'sweetalert2';
import attachmentService from '../../../../services/Shared/attachment.service';
import cpdReqService from '../../../../services/Shared/cpdReq.service';
import GenericPagination from '../../../Shared/Grid/GenericPagination';

function Courses(props) {
    const [displayLength, setDisplayLength] = useState(20);
    const [page, setPage] = useState(1);
    const getData = () => {

        return props.coursesModel.filter((v, i) => {
            const start = displayLength * (page - 1);
            const end = start + displayLength;
            return i >= start && i < end;
        })
    }
    const filteredData = getData();
    const formDataAppender = (passedKey, model, formData) => {
        for (let key in model) {
            if (typeof (model[key]) === 'object') {
                formDataAppender(`${passedKey}.${key}`, model[key], formData); // Recursive key for objects
            }
            else {
                if (passedKey)
                    formData.append(`${passedKey}.${key}`, model[key]);
                else
                    formData.append(`${key}`, model[key]);
            }
        }
    }

    const removeFile = (item, rowData) => {
        Swal.fire({
            title: 'Are you sure you want to delete this file?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                attachmentService.deleteFile(item.id).then((response) => {
                    if (response.status == 200) {
                        var index = props.coursesModel.findIndex(x => x.id == rowData.id);
                        var tempModel = props.coursesModel;
                        tempModel[index].files = tempModel[index].files.filter(x => x.id !== item.id);
                        props.setCoursesModel([...tempModel]);
                    }
                });
            }
        })
    }

    const openFile = (item) => {
        attachmentService.openFile(item.id);
    }

    const deleteRecord = (courseModel) => {
        var formData = new FormData();
        var courseRecord = {
            area: courseModel.area,
            classType: courseModel.classType,
            courseDate: (new Date(courseModel.date)).toISOString(),
            courseTitle: courseModel.title,
            description: courseModel.description,
            hours: courseModel.hours,
            entityId: props.entityId,
            id: courseModel.id,
            instructor: courseModel.instructor,
            dateCrte: courseModel.dateCrte,
            userCrte: courseModel.userCrte,
            deleted: true
        }
        formDataAppender('courseRecord', courseRecord, formData);
        for (var i = 0; i < courseModel.files.length; i++) {
            formData.append('files', courseModel.files[i].blobFile);
        }

        cpdReqService.postUpdateCpd(formData).then((response) => {
            if (response.status == 200) {
                props.setCoursesModel([...props.coursesModel.filter(x => x.id !== courseModel.id)]);
            }
        });
    }

    return (
        <Card>
            <Card.Header>
                <Row>
                    <Col className="d-flex align-items-center">
                        <h6>Individual Course Records</h6>
                    </Col>
                    <Col className="d-flex justify-content-end">
                        <Button onClick={props.openModal}>
                            <LegacyPlusIcon /> Add New</Button>
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body>
                <p>
                    <h5 style={{ color: "black" }}>Instructions: Uploading Certificates to Individual Course Records:</h5>
                    <ul>
                        <li>
                            <b>Click "Add New"</b>
                        </li>
                        <li>
                            <b>Enter Course Fields</b>
                            <ul>
                                <li>Fill in the required fields.</li>
                            </ul>
                        </li>
                        <li>
                            <b>Upload the Certificate</b>
                            <ul>
                                <li>Click <b>"Upload"</b> to select your certificate file (PDF, JPG, PNG, etc.).</li>
                            </ul>
                        </li>
                        <li>
                            <b>Submit the Record</b>
                            <ul>
                                <li>After entering the information and uploading the file, click <b>“Save”</b>.</li>
                            </ul>
                        </li>
                        <li>
                            <b>Repeat as Needed</b>
                            <ul>
                                <li>
                                    You can return to this section to upload certificates as you complete more courses.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </p>
                <Table headerHeight={60} data={filteredData} wordWrap autoHeight>
                    <Table.Column flexGrow={1} minwidth={100} verticalAlign="middle">
                        <Table.HeaderCell><b>Document</b></Table.HeaderCell>
                        <Table.Cell>
                            {rowData => {
                                return (<>
                                    {rowData.files.map((item, i) => {
                                        return (
                                            <Row key={i} style={{ padding: '0', display: 'flex' }}>
                                                {!item.legacy && <Col sm={1}><Button onClick={() => { removeFile(item, rowData) }} title={`Delete ${item.fileName}`} variant="link" style={{ color: "#EB0000", textDecoration: 'none' }} size="sm"><b>X</b></Button></Col>}
                                                <Col><Button onClick={() => { openFile(item) }} variant="link" size="sm">{item.fileName}</Button></Col>
                                            </Row>
                                        )
                                    })}
                                </>
                                )
                            }}
                        </Table.Cell>
                    </Table.Column>
                    <Table.Column flexGrow={0.5} verticalAlign="middle" >
                        <Table.HeaderCell><b>Date</b></Table.HeaderCell>
                        <Table.Cell>
                            {
                                rowData => {
                                    return (<span>{dayjs(rowData.date).format("MM/DD/YYYY")}</span>)
                                }
                            }
                        </Table.Cell>
                    </Table.Column>
                    <Table.Column flexGrow={0.8} verticalAlign="middle">
                        <Table.HeaderCell><b>Course Title</b></Table.HeaderCell>
                        <Table.Cell dataKey="title" />
                    </Table.Column>
                    <Table.Column flexGrow={0.8} verticalAlign="middle">
                        <Table.HeaderCell><b>Area</b></Table.HeaderCell>
                        <Table.Cell>
                            {
                                rowData => {
                                    return (<span>{rowData.area.area}</span>)
                                }
                            }
                        </Table.Cell>
                    </Table.Column>
                    <Table.Column flexGrow={0.5} verticalAlign="middle">
                        <Table.HeaderCell><b>Hours</b></Table.HeaderCell>
                        <Table.Cell dataKey="hours" />
                    </Table.Column>
                    <Table.Column width={100} verticalAlign="middle">
                        <Table.HeaderCell></Table.HeaderCell>
                        <Table.Cell dataKey="id">
                            {rowData => {
                                function handleAction() {
                                    var tempData = { ...rowData, modalType: 'Edit' }
                                    props.openModal(tempData);
                                }
                                function handleDelete() {
                                    Swal.fire({
                                        title: 'Are you sure?',
                                        text: "You won't be able to revert this!",
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        confirmButtonText: 'Yes, delete it!'
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            deleteRecord(rowData);
                                        }
                                    })
                                }
                                var showValues = !rowData.files.find(val => val.legacy);
                                return showValues &&
                                    <span>
                                        <LegacyEdit2Icon
                                            onClick={handleAction}
                                            style={{ cursor: "pointer" }}
                                            style={{
                                                fontSize: "2em"
                                            }} />&nbsp;&nbsp;
                                        <LegacyTrashIcon
                                            onClick={handleDelete}
                                            style={{ cursor: "pointer" }}
                                            style={{
                                                fontSize: "2em"
                                            }} />
                                    </span>;
                            }}
                        </Table.Cell>
                    </Table.Column>
                </Table>
                <GenericPagination dataLength={props.coursesModel.length} setPage={setPage} setDisplayLength={setDisplayLength} />
            </Card.Body>
        </Card>
    );
}

export default Courses

